const User = require('../entities/user');

const AccessContext = require('./contexts/access-context');

const fields = ['id', 'userId', 'roleId', 'propertyId', 'businessId', 'locationId'];

class ClaimRepo {
  constructor(client
  /*: ApiClient*/
  ) {
    this.client = client;
  }

  claim(context
  /*: AccessContext*/
  , user
  /*: User*/
  )
  /*: Promise<any>*/
  {
    const {
      propertyId
    } = context.serialize();
    const params = {
      propertyId,
      userId: user.id
    };
    const req = new this.client.Request(`/properties/claim`, params, fields);
    return this.client.post(req);
  }

  reclaim(context
  /*: AccessContext*/
  , user
  /*: User*/
  )
  /*: Promise<any>*/
  {
    const {
      propertyId
    } = context.serialize();
    const params = {
      propertyId,
      userId: user.id
    };
    const req = new this.client.Request(`/properties/reclaim`, params, fields);
    return this.client.post(req);
  }

}

module.exports = ClaimRepo;